var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("q-table", {
        ref: "table",
        staticClass: "q-mt-lg",
        attrs: {
          data: _vm.events,
          columns: _vm.columns,
          "row-key": "id",
          loading: _vm.loading,
          "no-data-label": _vm.$t("no_data_avaliable"),
          "no-results-label": _vm.$t("no_results_found"),
          "loading-label": _vm.$t("loading_data"),
          "rows-per-page-label": _vm.$t("items_per_page"),
          "rows-per-page-options": [5, 10, 50, 100],
          "binary-state-sort": ""
        },
        on: { request: _vm.requestEvents },
        scopedSlots: _vm._u([
          {
            key: "header",
            fn: function(props) {
              return _c(
                "q-tr",
                { attrs: { props: props } },
                _vm._l(props.cols, function(col) {
                  return _c(
                    "q-th",
                    { key: col.name, attrs: { props: props } },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$t(col.label)) +
                          "\n            "
                      )
                    ]
                  )
                }),
                1
              )
            }
          },
          {
            key: "body",
            fn: function(props) {
              return [
                _c(
                  "q-tr",
                  { attrs: { props: props } },
                  [
                    _c(
                      "q-td",
                      { key: "first_event_date", attrs: { props: props } },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.fDate(props.row.first_event_date)) +
                            "\n                "
                        )
                      ]
                    ),
                    _c("q-td", { key: "event_type", attrs: { props: props } }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.getEventType(props.row.event_type)) +
                          "\n                "
                      )
                    ]),
                    _c("q-td", { key: "test_type", attrs: { props: props } }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.getTestType(props.row.test_type)) +
                          "\n                "
                      )
                    ]),
                    _c("q-td", { key: "platform", attrs: { props: props } }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.getPlatformType(
                              props.row.platform,
                              props.row.event_type
                            )
                          ) +
                          "\n                "
                      )
                    ]),
                    _c(
                      "q-td",
                      {
                        key: "status",
                        attrs: { props: props, "auto-width": "" }
                      },
                      [
                        _c(
                          "q-chip",
                          {
                            staticClass: "full-width text-center",
                            attrs: {
                              small: "",
                              icon: _vm.getIconStatus(props.row.status),
                              color: _vm.getColorStatus(props.row.status)
                            }
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  _vm.$t(_vm.getTextStatus(props.row.status))
                                ) +
                                "\n                    "
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _c(
                      "q-td",
                      {
                        key: "actions",
                        attrs: { "auto-width": "", props: props }
                      },
                      [
                        _c(
                          "q-btn",
                          {
                            attrs: {
                              flat: "",
                              round: "",
                              color: "secondary",
                              icon: "fas fa-chalkboard-teacher"
                            },
                            on: {
                              click: function($event) {
                                return _vm.showEventUsers(props.row)
                              }
                            }
                          },
                          [
                            _c("q-tooltip", [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.$t("participants_report_tooltip")
                                  ) +
                                  "\n                        "
                              )
                            ])
                          ],
                          1
                        ),
                        _c(
                          "q-btn",
                          {
                            attrs: {
                              flat: "",
                              round: "",
                              color: "secondary",
                              icon: "fas fa-file-signature"
                            },
                            on: {
                              click: function($event) {
                                return _vm.showEventTests(props.row)
                              }
                            }
                          },
                          [
                            _c("q-tooltip", [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm.$t("tests_report_tooltip")) +
                                  "\n                        "
                              )
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            }
          }
        ])
      }),
      _c("event", {
        attrs: {
          show_event_report: _vm.show_event_report,
          event: _vm.event_id
        },
        on: {
          hide_event_report: function($event) {
            return _vm.hideEventReport()
          }
        }
      }),
      _vm.show_event_users
        ? _c("event-users", {
            attrs: {
              show_event_users: _vm.show_event_users,
              id: _vm.id,
              event_id: _vm.event_id,
              load: true,
              permissions: _vm.permissions
            },
            on: {
              hide_event_report: function($event) {
                return _vm.hideEventReport()
              }
            }
          })
        : _vm._e(),
      _vm.show_event_tests
        ? _c("event-tests", {
            attrs: {
              show_event_tests: _vm.show_event_tests,
              id: _vm.id,
              event_id: _vm.event_id,
              load: true,
              permissions: _vm.permissions
            },
            on: {
              hide_event_report: function($event) {
                return _vm.hideEventReport()
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }